import qs from 'qs';
import { createResource } from 'react-resource-router';

import { RUNNERS_STEP_QUEUE_PAGELEN } from 'src/components/pipelines/constants';
import {
  RunnersStepQueueItem,
  FetchRunnersStepQueueResponse,
} from 'src/components/pipelines/models';
import envBaseUrl from 'src/components/pipelines/utils/env-base-url';

import { fetchData } from './utils';

export type StepQueue = {
  queueItems: RunnersStepQueueItem[];
  remainingQueueSize: number;
  queueSize: number;
};

const getUrl = (workspaceSlug: string) => {
  return `${envBaseUrl(
    '/!api/internal'
  )}/workspaces/${workspaceSlug}/pipelines-config/step-queue/steps?${qs.stringify(
    {
      fields: '+values.step.name,+values.step.pipeline.uuid',
      pagelen: RUNNERS_STEP_QUEUE_PAGELEN,
    }
  )}`;
};

export const loadRunnersStepQueueResource = createResource<StepQueue | null>({
  type: 'runners-step-queue',
  getKey: ({ match }) =>
    match?.params?.workspaceSlug ||
    match?.params?.repositoryOwner ||
    'runners-step-queue',
  maxAge: 60000,
  getData: async ({ match }) => {
    const { workspaceSlug: workspaceSlugParam, repositoryOwner } = match.params;
    const workspaceSlug = repositoryOwner || workspaceSlugParam;

    if (!workspaceSlug) return null;

    const data: FetchRunnersStepQueueResponse = await fetchData(
      getUrl(workspaceSlug),
      'runners_step_queue_resource_exception'
    );

    return {
      queueItems: data.values.map(s => new RunnersStepQueueItem(s)),
      remainingQueueSize: data.size - data.values.length,
      queueSize: data.size,
    };
  },
});
